import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'
import * as Utils from '../utils'

export class SourceCell extends GridCell {

  public render() {
    return <td>
      <a target="_blank"
         rel="noopener noreferrer"
         href={Utils.sourceUrl(this.props.dataItem)}
         title={this.props.dataItem.source_url}>
        {this.props.dataItem.name}
      </a>
    </td>
  }
}



// WEBPACK FOOTER //
// ./src/pages/sources/render/source_cell.tsx